<div class="page-layout blank p-12" fusePerfectScrollbar>
    <div fxLayout="row">

        <button mat-icon-button (click)="info = !info" color="primary" class="mr-3"
            aria-label="Example icon button with a heart icon">
            <mat-icon *ngIf="!info">block</mat-icon>
            <mat-icon *ngIf="info" matBadge="{{this.obsEnterprise == null ? '0':'1' }}">info</mat-icon>
        </button>

        <mat-card [@animate]="{ value: '*', params: { delay: '500ms', y: '100%' } }" *ngIf="!info"
            style="background-color: #4AADC2"><b>Informativo:</b>
            <div *ngFor="let item of this.obsEnterprise">
                <p> {{ item || 'Sem informativo' }} </p>
            </div>
        </mat-card>
    </div>

    <div *ngIf="!newSchedule" class="w-100-p h-100-p">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-8">

            <div class="mt-12" fxLayoutalign="end">
                <button id="newScheduleButton" color="accent" (click)="checkScheduleLimit()"
                    matTooltip="Novo agendamento" mat-raised-button class="mr-sm-12">
                    Novo agendamento
                </button>
            </div>
        </div>
        <div *ngIf="!dataSource.length">
            <!-- <p>Mensagem de historico vazio</p> -->
        </div>

        <mat-tab-group (selectedIndexChange)="onTabChange($event)">
            <!-- ABA 1 -->
            <mat-tab label="Agendamentos Futuros">
                <ng-container *ngIf="dataSource.length; else emptyFuturos">
                    <div class="cards-container">
                        <div class="card-item" *ngFor="let element of dataSource">
                            <div class="card-header">
                                <div class="card-date">
                                    {{ element.date | date: "dd/MM/yy" }} - {{ element.hour.substring(0, 5) }}
                                </div>
                            </div>

                            <div class="card-body">
                                <div class="info-line">
                                    <span class="label">Unidade:</span>
                                    <span class="value">{{ element.companyName }}</span>
                                </div>
                                <div class="info-line">
                                    <span class="label">Profissional:</span>
                                    <span class="value">{{ element.performerName }}</span>
                                </div>
                                <div class="info-line">
                                    <span class="label">Procedimento:</span>
                                    <span class="value">{{ element.procedureName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Paginator fora do grid -->
                    <div class="paginator-wrapper">
                        <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                            [pageSizeOptions]="[10, 25]" (page)="getSCheduleList($event, 'page')">
                        </mat-paginator>
                    </div>
                </ng-container>

                <ng-template #emptyFuturos>
                    <div class="empty-state">Nenhum agendamento encontrado.</div>
                </ng-template>
            </mat-tab>

            <!-- ABA 2 -->
            <mat-tab label="Histórico">
                <ng-container *ngIf="dataSource.length; else emptyHistorico">
                    <div class="cards-container">
                        <div class="card-item" *ngFor="let element of dataSource">
                            <div class="card-header">
                                <div class="card-date">
                                    {{ element.date | date: "dd/MM/yy" }} - {{ element.hour.substring(0, 5) }}
                                </div>
                            </div>

                            <div class="card-body">
                                <div class="info-line">
                                    <span class="label">Unidade:</span>
                                    <span class="value">{{ element.companyName }}</span>
                                </div>
                                <div class="info-line">
                                    <span class="label">Profissional:</span>
                                    <span class="value">{{ element.performerName }}</span>
                                </div>
                                <div class="info-line">
                                    <span class="label">Procedimento:</span>
                                    <span class="value">{{ element.procedureName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Paginator fora do grid -->
                    <div class="paginator-wrapper">
                        <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                            [pageSizeOptions]="[10, 25]" (page)="getSCheduleHistoryList($event, 'page')">
                        </mat-paginator>
                    </div>
                </ng-container>

                <ng-template #emptyHistorico>
                    <div class="empty-state">Nenhum histórico encontrado.</div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>



    </div>

    <div *ngIf="newSchedule">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                <h4>Agendamento</h4>
            </div>

            <button id="newScheduleButton" color="accent" (click)="toggleHistory()" matTooltip="Novo agendamento"
                mat-raised-button class="mt-12">
                Histórico
            </button>
        </div>

        <form class="w-100-p mt-8">

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Convênio</mat-label>
                <input type="text" placeholder="Nome" aria-label="Number" matInput [formControl]="insuranceControl"
                    [matAutocomplete]="auto2" required="required" />
                <button *ngIf="insuranceControl.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="insuranceControl.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnInsurance">
                    <mat-option *ngFor="let insurance of insuranceList" [value]="insurance">
                        {{ insurance.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Unidade</mat-label>
                <mat-select [(ngModel)]="unityValue" name="unit" (ngModelChange)="onUnityChange()" required="required">
                    <mat-option *ngFor="let unit of unitList" [value]="unit">
                        {{ unit.tradeName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Especialidade</mat-label>
                <input type="text" placeholder="Nome" aria-label="Nome" matInput [formControl]="specialityControl"
                    [matAutocomplete]="auto" required="required" />
                <button *ngIf="specialityControl.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="specialityControl.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnSpeciality">
                    <mat-option *ngFor="let speciality of specialityList" [value]="speciality">
                        {{ speciality.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline" *ngIf="specialityControl.value">
                <mat-label>Profissional</mat-label>
                <input type="text" placeholder="Nome" aria-label="Number" matInput [formControl]="professionalControl"
                    [matAutocomplete]="auto" />
                <button *ngIf="professionalControl.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="professionalControl.setValue('')">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnProfessional">
                    <mat-option *ngFor="
                            let performer of professionalList 
                        " [value]="performer">
                        {{ performer.performerName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline" *ngIf="this.prepareProcedureControl.value">
                <mat-label>Preparo</mat-label>
                <textarea matInput placeholder="Preparo" [formControl]="prepareProcedureControl"
                    readonly="readonly"></textarea>
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Observação</mat-label>
                <textarea matInput placeholder="Obs.." [formControl]="observableControl"></textarea>
            </mat-form-field>

        </form>

        <div style="bottom: 0; right: 0" fxLayout="row" class="mb-12">
            <div class="ml-8">
                <button id="newScheduleButton" color="accent" matTooltip="Buscar agenda" mat-raised-button
                    class="mr-sm-12" (click)="getScheduleeList()" [disabled]="loadingSchedule">
                    <ng-container *ngIf="!loadingSchedule; else loadingTpl">
                        Buscar agenda
                    </ng-container>
                    <ng-template #loadingTpl>
                        <div class="spinner-center">
                            <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"
                                strokeWidth="3"></mat-progress-spinner>
                        </div>
                    </ng-template>
                </button>
            </div>
        </div>

        <div class="schedule-container" #scheduleContainer>
            <mat-card *ngFor="let group of groupedSchedules" class="schedule-card" appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        <span class="date-text">{{ group.date | date:'EEEE, dd/MM/yyyy' }}</span>
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>
                    <div *ngFor="let perf of group.performers" class="performer-block">
                        <div class="performer-info">
                            <div class="performer-name">{{ perf.performerName }}</div>
                            <div class="speciality">{{ perf.specialityName }}</div>
                        </div>

                        <mat-chip-listbox class="chip-list" aria-label="Horários disponíveis">
                            <mat-chip-option *ngFor="let item of perf.hours" color="primary"
                                (click)="handleSchedule(item)">
                                {{ item.hour }}
                            </mat-chip-option>
                        </mat-chip-listbox>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div style="bottom: 0; right: 0" fxLayout="row" class="mb-12" *ngIf="scheduleList.length > 0">
            <div class="ml-8">
                <button id="newScheduleButton" color="accent" matTooltip="Buscar agenda" mat-raised-button
                    class="mr-sm-12" (click)="getScheduleeList(50)" [disabled]="loadingSchedule">
                    <ng-container *ngIf="!loadingSchedule; else loadingMoreTpl">
                        Buscar mais
                    </ng-container>
                    <ng-template #loadingMoreTpl>
                        <div class="spinner-center">
                            <mat-progress-spinner diameter="24" mode="indeterminate" color="primary"
                                strokeWidth="3"></mat-progress-spinner>
                        </div>
                    </ng-template>
                </button>
            </div>
        </div>

    </div>
</div>
